import { Directive, HostListener, Injector, OnInit } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
    selector: '[ptAllowOnlyOneSpace]',
    standalone: true,
})
export class AllowOnlyOneSpaceDirective implements OnInit {
    private control: NgControl;

    @HostListener('blur') onBlur() {
        if (!this.control.value) {
            return;
        }

        const newValue = this.removeSpaces(this.control.value, true);
        if (newValue !== this.control.value && this.control.control) {
            this.control.control.setValue(newValue);
        }
    }

    @HostListener('input', ['$event']) onInput(event: Event) {
        const element = event.target as HTMLInputElement;
        if (element.selectionStart)
            if (element.selectionStart < this.control.value.length) {
                return;
            }

        const newValue = this.removeSpaces(this.control.value, false);
        if (newValue !== this.control.value && this.control.control) {
            this.control.control.setValue(newValue);
        }
    }

    constructor(private injector: Injector) {}

    ngOnInit() {
        this.control = this.injector.get(NgControl);
    }

    private removeSpaces(value: string, trim: boolean) {
        value = value.replace(/^ +/, '');

        // find first space, then remove all subsequent spaces
        const firstSpaceIdx = value.indexOf(' ');
        if (firstSpaceIdx >= 0) {
            value = value.slice(0, firstSpaceIdx + 1) + value.slice(firstSpaceIdx + 1).replace(/ /g, '');
        }

        // trim also at the end when moving on to other fields
        if (trim) {
            value = value.replace(/ +$/, '');
        }

        return value;
    }
}
